module.exports = __webpack_public_path__ + "static/media/linkedin.1321c42a.png";